import {
  ContentWrapper,
  StyledBannerFakeButton,
  StyledBannerHeading,
  StyledBannerImg,
} from "src/molecules/PromotionBanner/PromotionBanner.styled";
import { Text } from "@otrium/atoms";
import { Box, Flex } from "@otrium/core";
import { FC } from "react";
import { PromotionBannerProps } from "./PromotionBannerTypes";

const PromotionBannerTypeOne: FC<PromotionBannerProps> = ({
  bannerImageSrc,
  title,
  description,
  buttonTitle,
  buttonColor,
  buttonTextColor,
  backgroundColor,
  conditionText,
  hideCTAButton,
  titleColor,
  textColor,
}) => {
  return (
    <Box sx={{ position: "relative" }}>
      <StyledBannerImg src={bannerImageSrc} />
      <ContentWrapper>
        <Flex
          flexDirection="column"
          alignItems="center"
          mt={["space32", "space32", "12px", "20px"]}
          paddingX={["space16", "space0", "space0", "space0"]}
        >
          <StyledBannerHeading
            as="h1"
            color={titleColor || "tone.white"}
            fontWeight="700"
          >
            {title}
          </StyledBannerHeading>
          {description && (
            <Text
              fontSize={["fontSize18", "fontSize18", "22px"]}
              lineHeight={["24px", "24px", "32px"]}
              textAlign="center"
              color={textColor || "tone.white"}
              mb="space16"
            >
              {description}
            </Text>
          )}
          {!hideCTAButton ? (
            <StyledBannerFakeButton
              textColor={buttonTextColor}
              buttonColor={buttonColor}
            >
              {buttonTitle}
            </StyledBannerFakeButton>
          ) : null}
          {conditionText && (
            <Text fontSize={"fontSize12"} color={textColor || "tone.white"}>
              {conditionText}
            </Text>
          )}
        </Flex>
      </ContentWrapper>
    </Box>
  );
};

export default PromotionBannerTypeOne;
